

jQuery(function ($) {
    // Slick
    $('.home .featured-posts .slick-slider').slick({
        arrows: false,
    });

    /*  
       // Custom carousel nav
       $('.carousel-prev').click(function () {
           $(this).parent().find('.slick-slider').slick('slickPrev');
       });
   
       $('.carousel-next').click(function (e) {
           e.preventDefault();
           $(this).parent().find('.slick-slider').slick('slickNext');
       }); */
});
var validateEmail = (email) => {
    var re = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return re.test(String(email).toLowerCase());
}

$(function () {
    $('.adjust-height').matchHeight();
});

(function ($) {
    $(() => {


        var isIE = /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /MSIE 10/i.test(navigator.userAgent) || /Edge\/\d+/.test(navigator.userAgent);
        if (isIE) {
            document.body.classList.add('ie');
        }

        objectFitVideos();

        if ($('.js-ios-video').length) {
            $('.js-ios-video').each(function () {
                enableInlineVideo(this);
            });

        }


        $('.js-nav-scroll-to a').on('click', function (e) {

            var $selector = this.hash;

            $('.hamburger.is-active').trigger('click');
            $("html, body").animate({
                scrollTop: $($selector).offset().top - 60
            }, 1000, function () {
                //window.location.hash = $selector;

            });
            e.preventDefault();

        });


        var anchor = window.location.hash;
        if (anchor) {
            $('html, body').animate({
                scrollTop: $(anchor).offset().top - 60
            }, 1000, function () {
                // window.location.hash = anchor;
            });
        }


        /*    const images = document.querySelectorAll('.hero-logo');
    
                    if (images.length) {
            
                        var observer = new IntersectionObserver((entries) => {
                            entries.forEach(entry => {
                                if (entry.intersectionRatio > 0) {
                                    console.log('latható');
                                } else {
                                    console.log('nemlatható');
                                }
                            });
                        }); 
    
            images.forEach(image => {
                observer.observe(image);
            });
        } */




        $('.slider-main').each(function (e) {

            var $that = $(this);

            $that.on('init reInit', function (event, slick) {
                var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
                if (current > 1) {
                    var currentrounded = Math.ceil(current.toFixed(2));
                    $that.parent().parent().find('.js-paginginfo').append('<span class="first-number">1</span><span class="temp">/</span><span class="second-number">' + currentrounded + '</span>');
                }
            });
            $that.slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: true,
                prevArrow: $that.parent().parent().find('.carousel-prev'),
                nextArrow: $that.parent().parent().find('.carousel-next'),
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });

            $that.on('afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + slick.options.slidesToShow;
                var current = slick.slideCount / parseFloat(slick.options.slidesToShow);
                if (current > 1) {
                    var currentrounded = Math.ceil(current.toFixed(2));
                    $that.parent().parent().find('.first-number').text(i / parseFloat(slick.options.slidesToShow));
                    $that.parent().parent().find('.second-number').text(currentrounded);
                }
            });

        })


        objectFitImages();

        $(window).scroll(function () {
            if ($(window).scrollTop() > 10) {
                $('.navbar').addClass('is-scrolled');
            } else {
                $('.navbar').removeClass('is-scrolled');
            }
        });

        $('.collapse').on('hidden.bs.collapse', function () {
            bodyScrollLock.enableBodyScroll();
        });


        $('.collapse').on('shown.bs.collapse', function () {
            bodyScrollLock.disableBodyScroll();
        });

        $('.js-scroll-to').on('click', function (e) {
            e.preventDefault();
            var $selector = $(this).parent().next();
            $("html, body").animate({
                scrollTop: $selector.offset().top - 60
            }, 1000);
        });







    });
})(jQuery);
